<style scoped>
main {
  margin-top: 64px;
  min-height: 80vh;
}
</style>

<template lang='pug'>
div
  app-header(:showFixed='true')
  main
    transition(name='fade', mode='out-in')
      router-view
  app-footer
  vue-modal(v-if='modalProperties.isShown', :options='modalProperties.style')
    component(:is='modalProperties.content', v-bind='modalProperties.params')
</template>
<script>
import AppHeader from './app-header.vue'
import AppFooter from './app-footer.vue'
import VueModal from 'vue-modal'

export default {
  meta: {
    title: 'Spirits & Liquor Direct',
    titleTemplate: '%s - Inom PH'
  },
  data () {
    return {}
  },
  computed: {
    modalProperties () {
      return {
        isShown: this.$store.state.modal.isShown,
        content: this.$store.state.modal.content,
        params: this.$store.state.modal.bind,
        style: this.$store.state.modal.style
      }
    }
  },
  components: {
    AppHeader,
    AppFooter,
    VueModal
  }
}
</script>



// WEBPACK FOOTER //
// src/components/template-default.vue